import * as tracking from 'dibs-tracking';
import { PricingGuidancePriceRange } from './__generated__/pricingGuidanceHelpers_item.graphql';

type PriceRange = PricingGuidancePriceRange | null;

export function getPriceStatus(priceRange: PriceRange): string {
    switch (priceRange) {
        case 'OUT_OF_RANGE_LOW':
            return 'below min price';
        case 'LOWER_RANGE':
            return 'between min and ten percent less than median';
        case 'NEAR_MEDIAN_LOW':
            return 'ten percent less than median';
        case 'MEDIAN':
            return 'equal to median price';
        case 'NEAR_MEDIAN_HIGH':
            return 'ten percent more than median';
        case 'HIGHER_RANGE':
            return 'between ten percent more than median and max';
        case 'OUT_OF_RANGE_HIGH':
            return 'above max price';
        default:
            return 'other';
    }
}

export function trackPricingGuidanceModuleView(priceRange: PriceRange): void {
    const priceStatus = getPriceStatus(priceRange);
    tracking.trackEvent({
        category: 'product',
        action: 'recent sales module reached',
        label: `pdp - ${priceStatus}`,
        noninteraction: 1,
    });
}

export function trackPricingGuidanceModuleTooltipView(priceRange: PriceRange): void {
    const priceStatus = getPriceStatus(priceRange);
    tracking.trackEvent({
        category: 'product',
        action: 'recent sales info icon clicked',
        label: `pdp - ${priceStatus}`,
        noninteraction: 0,
    });
}

export function trackPricingGuidanceModuleBrowseSimilarLinkClick(priceRange: PriceRange): void {
    const priceStatus = getPriceStatus(priceRange);
    tracking.trackEvent({
        category: 'product',
        action: 'browse similar clicked',
        label: `pdp - ${priceStatus}`,
        noninteraction: 0,
    });
}
